import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }

  > .MuiFormControl-root {
    margin-bottom: 1rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const WrapperGrid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }
`;
